import React from "react";
import { Helmet } from "react-helmet";

import BannerCshHolding from "components/CnpHolding/BannerCnpHolding";
import CshHoldingAdvice from "components/CnpHolding/CnpHoldingAdvice";
import CshHoldingPresenceInfo from "components/CnpHolding/CnpHoldingPresenceInfo";
import CnpHoldingCards from "components/CnpHolding/CnpHoldingCards";
import CnpHoldingVideos from "components/CnpHolding/CnpHoldingVideos";

const CnpHolding = () => {
  return (
    <article>
      <Helmet>
        <title>CNP Seguros Holding | Quem somos</title>
        <meta
          name="description"
          content="Com 21 anos no mercado, somos a terceira maior seguradora do País: a Caixa Seguradora, que cuidou e trouxe soluções para milhões de brasileiros."
        />
        <meta
          name="keywords"
          content="CNP Seguros, CNP Brasil, histórias, confiança, parcerias, futuro, brasileiro, novos tempos, inovação"
        />
      </Helmet>
      <BannerCshHolding />
      <CshHoldingAdvice />
      <CnpHoldingCards />
      <CnpHoldingVideos />
      <CshHoldingPresenceInfo />
    </article>
  );
};

export default CnpHolding;
